import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/autoplay"; // Import autoplay styles

// Import required Swiper modules
import { EffectCards, Autoplay } from "swiper/modules";

// Import images
import homeImage1 from "../assets/RIGVE - Premium Texture/1669269909037HAS_4-1-768x512.jpg";
import homeImage2 from "../assets/RIGVE - Premium Texture/1.1.0-1024x503.jpg";
import homeImage7 from "../assets/RIGVE - Premium Texture/IMG_E9831-1024x1024.jpg";

const imageData = [
  {
    id: 1,
    image: homeImage1,
    title: "Natural Stone Cladding",
  },
  {
    id: 2,
    image: homeImage2,
    title: "Natural Stone Tiles",
  },
  // {
  //   id: 3,
  //   image: homeImage3,
  //   title: "Natural Stone Pavers",
  // },
  // {
  //   id: 4,
  //   image: homeImage4,
  //   title: "Natural Stone Pavers",
  // },
  // {
  //   id: 5,
  //   image: homeImage5,
  //   title: "Natural Stone Pavers",
  // },
  // {
  //   id: 6,
  //   image: homeImage6,
  //   title: "Natural Stone Pavers",
  // },
  {
    id: 7,
    image: homeImage7,
    title: "Natural Stone Pavers",
  },
];

const slideTexts = [
  {
    tagline: "WHERE TEXTURE MEETS LUXURY",
    title: "Premium Wall Textures & Designer Finishes",
    description:
      "Transform ordinary walls into extraordinary masterpieces with Rigve Premium Textures. From Lime Plaster and Concrete Effects to Luxury Decorative Finishes, we create elegant spaces that reflect timeless beauty, durability, and sophistication.",
  },
  {
    tagline: "WHERE TEXTURE MEETS LUXURY",
    title: "Premium Wall Textures & Designer Finishes",
    description:
      "Transform ordinary walls into extraordinary masterpieces with Rigve Premium Textures. From Lime Plaster and Concrete Effects to Luxury Decorative Finishes, we create elegant spaces that reflect timeless beauty, durability, and sophistication.",
  },
  {
    tagline: "WHERE TEXTURE MEETS LUXURY",
    title: "Premium Wall Textures & Designer Finishes",
    description:
      "Transform ordinary walls into extraordinary masterpieces with Rigve Premium Textures. From Lime Plaster and Concrete Effects to Luxury Decorative Finishes, we create elegant spaces that reflect timeless beauty, durability, and sophistication.",
  },
];

export const ImageCardSlider = () => {
  const [ImageData, setImageData] = useState([]);
  const imageData = ImageData?.map((item, index) => ({
    id: item?.id,
    image: item?.image,
    title: item?.name,
    className: "col-span-1 row-span-1",
  }));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchImageData = async () => {
      try {
        const response = await fetch(
          "https://webadmin.rigve.com/api/getgallery?type=1",
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response?.json();
        if (data.status === 1) {
          setImageData(data?.data?.data);
        } else {
          throw new Error("Failed to fetch gallery data");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImageData();
  }, []);
  return (
    <div className="">
      <Swiper
        // effect={"cards"}
        grabCursor={true}
        initialSlide={1}
        speed={2000}
        autoplay={{
          delay: 2000, // Change slide every 1 second (1000 ms)
          disableOnInteraction: false, // Allow autoplay to continue after user interaction
        }}
        modules={[EffectCards, Autoplay]} // Include Autoplay module
        className="mySwiper w-full h-[100vh]"
      >
        {imageData.map((item, index) => {
          const textInfo = slideTexts[index % slideTexts.length];
          return (
            <SwiperSlide key={item.id}>
              <div className="relative w-full h-[100vh] bg-gray-900 overflow-hidden shadow-lg">
                {/* <img
                  src={item.image}
                  alt={item.title}
                  className="w-[100vw] h-[100vh] opacity-15 object-cover"
                /> */}
                <img
                  src={item.image}
                  alt={item?.title || "Rigve premium texture finish"}
                  className="absolute inset-0 w-[100vw] h-[100vh] object-cover object-center scale-105"
                  loading="lazy"
                />

                {/* OVERLAY (MATCH IMAGE EXACT WIDTH ISSUE FIXED) */}
                <div className="absolute inset-0 bg-black/30"></div>

                {/* CENTER CONTENT (FIXED ALIGNMENT ON ALL DEVICES) */}
                <div className="relative z-10 flex items-center justify-center h-full px-4 text-center">
                  <div className="max-w-3xl space-y-6">
                    {/* TAGLINE */}
                    <p className="text-orange-400 text-sm md:text-base font-semibold tracking-widest uppercase opacity-100">
                      "{textInfo.tagline}"
                    </p>

                    {/* TITLE */}
                    <h1 className="text-white text-2xl sm:text-4xl font-bold leading-tight opacity-100">
                      {textInfo.title}
                    </h1>

                    {/* DESCRIPTION */}
                    <p className="text-gray-200 text-sm sm:text-base md:text-lg leading-relaxed opacity-90">
                      {textInfo.description}
                    </p>

                    {/* BUTTONS */}
                    <div className="flex flex-col sm:flex-row justify-center gap-4 pt-4">
                      <a
                        href="/App#products_home"
                        className="px-7 py-3 rounded-full bg-orange-600 text-white font-semibold shadow-lg hover:bg-orange-700 transition opacity-100"
                        aria-label="Explore premium collection"
                      >
                        Explore More
                      </a>

                      <a
                        href="/contact"
                        className="px-7 py-3 rounded-full border border-white/40 text-white font-semibold hover:bg-white/10 transition opacity-100"
                        aria-label="Contact design experts"
                      >
                        Get Consultation
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
